import { defineModule } from "../define.ts";

/** Push-to-talk staff radio (docs/spec/radio.md): one half-duplex channel per site. */
export const radio = defineModule({
  id: "radio",
  name: "Staff radio",
  version: "1.0.0",
  description: "Push-to-talk walkie-talkie for staff, teachers and the door kiosk (listen only).",
  core: true,
  grants: { "radio:use": ["org_admin", "site_admin", "door_staff", "teacher"] },
});
